export default function () {
  return {
    current: {
      id: '',
      active: false,
      allowUpgrade: false,
      gitTagVersion: '',
      approvedGitVersions: [],
      clientVersion: '',
      core_id: '',
      keyConnected: false,
      hasRpiClient: false,
      name: '',
      reenableTime: null,
      ip: '',
      internalIp: '',
      lastBackupLog: '',
      lastLog: '',
      lastConnection: '',
      rpiMacAddress: '',
      systems: [],
      users: []
    },
    update: {
      id: '',
      active: false,
      gitTagVersion: '',
      hasRpiClient: false,
      name: '',
      reenableTime: null,
      allowUpgrade: false
    },
    availableOrgs: {},
    clients: [],
    list: [],
    health_list: [],
    inactive: 0,
    organizations: 0,
    organizationsOk: 0,
    systems: 0,
    systemsOk: 0,
    overdue: 0,
    manual: {
      ok: 0,
      count: 0,
      overdue: 0
    },
    automatic: {
      ok: 0,
      count: 0,
      overdue: 0
    },
    notBackedup: 0
  }
}
